import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import AppConfigPageView from "@/views/appconfig/AppConfigPageView.vue";

import {onMounted, ref} from "vue";
import {UIHandleGet} from "@/views/utils";
import AppConfigAPI from "@/api/AppConfigAPI";



const __default__ = {
  name: 'HomeView',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const pageId = ref<string>("")

const request = async () => {
  let idResult = await UIHandleGet(AppConfigAPI.pcHomePageId())
  pageId.value = idResult.id
}

onMounted(async () => {
  await request()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (pageId.value)
      ? (_openBlock(), _createBlock(AppConfigPageView, {
          key: 0,
          id: pageId.value
        }, null, 8, ["id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})